export default "<!--Chat component-->\n<div id=\"trobbit-chatbot\"></div>\n<!--End chat component-->\n\n\n"